import { render, staticRenderFns } from "./ModalThemeApp.vue?vue&type=template&id=2bbb5d94&"
import script from "./ModalThemeApp.vue?vue&type=script&lang=js&"
export * from "./ModalThemeApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports